import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "FacilityMaintenanceVendorsTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no vendors to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching vendors found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "facility_maintenance_vendors"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Name",
					value: "name"
				},
				{
					text: "Category",
					value: "vendorType.name"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteVendor( vendor ) {
			const deleteIndex = this.items.findIndex( item => vendor.id === item.id );

			return vendor.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "facilityMaintenanceVendor",
								params: { idVendor: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete vendor" )}
								onConfirm={() => this.deleteVendor( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Vendor"
							>
								Are you sure you want to delete the maintenance vendor <strong>{item.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
